export default __webpack_public_path__ + "static/trailblazerold-d7eacb3f9d3691b308aadd939eb685d5.png";